
import {
  defineComponent,
  getCurrentInstance,
  onUnmounted,
  computed,
  onMounted,
  ref,
} from "vue";
import DownloadModal from "@/components/DownLoadModal/index.vue";
import InputSearch from './components/input.vue'
import { sendLog, getKwaiLog } from '@/common/radar';
import { openNewWindow } from "~/common/utils";

export default defineComponent({
  components: {
    DownloadModal,
    InputSearch
  },
  props: {
    pageType:{
      type: String,
      default: 'normal'
    }
  },
  setup(props, ctx) {

    const { proxy } = getCurrentInstance() as any;
    const iconShow=ref<string>(proxy.$store.state.isSnack ? 'snack' : 'kwai')
    
    const loading = ref(false);

    const showDownloadModel = () => {
      sendLog({
          type: 'click',
          name: 'TOP_CLICK_AREA',
          value: {
            button_type: 'download'
          }
      })
      proxy.$bus.emit('show-download', true)
    };

    const inputValue = ref<string>("");

    const setLoading = (isLoading: boolean) => {
        loading.value = isLoading;
    };

    const handleLogoClick = () => {
      sendLog({
          type: 'click',
          name: 'TOP_CLICK_AREA',
          value: {
            button_type: 'logo'
          }
      })
      openNewWindow('/')
    }
    
    const handleInputClick = () => {
        sendLog({
            type: 'click',
            name: 'TOP_CLICK_AREA',
            value: {
              button_type: 'search_input'
            }
        })
    }

    onMounted(() => {
        proxy.$bus.on("isLoad", setLoading);
        inputValue.value = proxy.$store.state.searchValue
    });

    onUnmounted(() => {
      proxy.$bus.off("isLoad", setLoading);
    });

    return {
      loading,
      inputValue,
      showDownloadModel,
      iconShow,
      handleLogoClick,
      handleInputClick,
    };
  },
});
